<template>
  <div class="text-center checkout">
    <div v-if="text != ''" style=" padding-top: 20vh; height:100vh" :class="'bg-' + variant" class="text-white">
      <!-- Message Box -->
      <h2 style="font-size: 3em;">{{ companyName }}</h2>
      <h1 style="font-size: 5em;" v-if="userName && companyName">{{ userName }}</h1>
      <p style="font-size: 4em;">{{ text }}</p>
      <div style="font-size: 12em;">{{ checkoutTime }}</div>
    </div>
    <div style="font-size: 4em; padding-top: 20vh;" v-if="text == ''">
      <div>Przytknij kartę do czytnika</div>
      <div>{{ time }}</div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { CardResource } from '@/resources/card.resource';

export default {
  data() {
    return {
      cardNumber: '',
      text: '',
      userName: '',
      companyName: '',
      variant: null,
      clearDataTimeout: null,
      time: null,
      checkoutTime: '',
      timestamp: null,
      cardsUsed: []
    };
  },
  methods: {
    keyup(event) {
      if (event.key > -1 && event.key < 10) {
        this.cardNumber += event.key;
      } else if (event.key === 'Enter' && this.cardNumber !== '') {
        this.checkout(this.cardNumber);
        this.clearCardNumber();
      } else {
        this.clearCardNumber();
      }
    },
    clearCardNumber() {
      this.cardNumber = '';
    },
    async checkout(cardNumber) {
      this.cancelClearingData();
      if (this.cardsUsed.indexOf(cardNumber) > -1) {
        return;
      }
      try {
        const response = await CardResource.checkout(cardNumber);
        if (response) {
          this.useCard(cardNumber);
          this.notifyAboutSuccess(response);
          this.deferClearData();
        }
      } catch (error) {
        this.notifyAboutError();
      }
    },
    useCard(cardNumber) {
      this.cardsUsed.push(cardNumber);
      setTimeout(cn => {
        this.cardsUsed.splice(this.cardsUsed.indexOf(cn), 1);
      }, 10000);
    },
    notifyAboutSuccess(checkoutResponse) {
      const time = moment(checkoutResponse.date);
      this.userName = `${checkoutResponse.user.firstName} ${checkoutResponse.user.lastName}`;
      this.companyName = checkoutResponse.company.name;
      if (!checkoutResponse.end) {
        this.notifyAboutStart(checkoutResponse, time);
      } else if (checkoutResponse.end) {
        this.notifyAboutEnd(checkoutResponse, time);
      }
    },
    notifyAboutStart(checkoutResponse, time) {
      time.add(checkoutResponse.start, 'minutes');
      this.text = 'Odnotowano początek pracy';
      this.checkoutTime = time.format('LT');
      this.variant = 'primary';
    },
    notifyAboutEnd(checkoutResponse, time) {
      time.add(checkoutResponse.end, 'minutes');
      this.text = 'Odnotowano koniec pracy';
      this.checkoutTime = time.format('LT');
      this.variant = 'success';
    },
    notifyAboutError(error) {
      this.deferClearData();
      this.variant = 'danger';
      this.text = 'Wystąpił błąd!';
      this.userName = '';
      this.companyName = '';
      console.warn(error);
    },
    clearData() {
      clearTimeout(this.clearDataTimeout);
      this.userName = '';
      this.companyName = '';
      this.text = '';
      this.cardNumber = '';
      this.checkoutTime = '';
      this.clearDataTimeout = null;
      this.variant = null;
    },
    deferClearData() {
      this.clearDataTimeout = setTimeout(this.clearData, 4000);
    },
    cancelClearingData() {
      clearTimeout(this.clearDataTimeout);
    },
    clock() {
      this.time = moment(new Date()).format('DD.MM.YYYY HH:mm');
      setTimeout(this.clock, 1000);
    },
    watchServerChanges() {
      const fiveMinutes = 5 * 60 * 1000;
      setInterval(() => {
        fetch('./version.json?' + new Date().getTime())
          .then(res => res.json())
          .then(json => {
            console.warn('Version check');
            json.timestamp !== this.timestamp ? location.reload() : console.log('No changes');
          })
          .catch(error => {
            console.warn(error);
          });
      }, fiveMinutes);
    }
  },
  mounted() {
    document.addEventListener('keyup', this.keyup);
    this.clock();
  },
  beforeMount() {
    fetch('./version.json?' + new Date().getTime())
      .then(res => res.json())
      .then(json => {
        if (json.timestamp) {
          this.timestamp = json.timestamp;
          this.watchServerChanges();
        }
      })
      .catch(error => {
        console.warn(error);
      });
  }
};
</script>
<style scoped>
.checkout {
  min-height: 100vh;
  cursor: none;
  color: #333;
}
</style>
